import { KpiDataType } from "../types/kpiConfigTypes";


export default function getValidKpiVisibility(){
  const kpiAvailabilityData = validateKpiConfig(window?.config?.KPIS_VISIBILITY_CONFIG);

  if (!kpiAvailabilityData) {
    console.error("KPIS_VISIBILITY_CONFIG content is invalid!");
  }
  
  return kpiAvailabilityData as KpiDataType;
}

function validateKpiConfig(kpisData: any): KpiDataType | null {
  if (!kpisData || typeof kpisData !== 'object') {
    console.log('Error: Invalid data format for Kpis')
    return null;
  }
  return kpisData as KpiDataType;
}

